import PocketBase from 'pocketbase';

const pbUrl = import.meta.env.VITE_PB_URL || 'https://expenses.gtintl.com.ph/pb';
export const pb = new PocketBase(pbUrl);

const TABLE_MAP = {
  'expenses_1739880000000': 'expenses',
  'topups_1739880000000': 'topups',
  'weekly_balance_1739880000000': 'weekly_balance',
};

const normalizeRecord = (record) => {
  const { collectionId, collectionName, expand, ...rest } = record;
  return rest;
};

const makeShim = () => {
  const from = (collection) => {
    const mapped = TABLE_MAP[collection] || collection;
    return {
      _collection: mapped,
      _filters: [],
      _order: [],
      _limit: 500,
      _single: false,
      select(_cols) { return this; },
      eq(field, val) { this._filters.push(`${field}="${val}"`); return this; },
      gte(field, val) { this._filters.push(`${field}>="${val}"`); return this; },
      lte(field, val) { this._filters.push(`${field}<="${val}"`); return this; },
      order(field, opts) {
        const asc = opts && opts.ascending === true;
        const f = field === 'created_at' ? 'created' : field === 'updated_at' ? 'updated' : field; this._order.push(asc ? f : `-${f}`);
        return this;
      },
      limit(n) { this._limit = n; return this; },
      single() { this._single = true; return this; },
      async then(resolve) {
        try {
          const filter = this._filters.join(' && ') || '';
          const sort = this._order.length ? this._order.join(',') : '-created';
          const list = await pb.collection(this._collection).getList(1, this._limit, {
            filter, sort
          });
          if (this._single) {
            if (list.items.length === 0)
              return resolve({ data: null, error: { code: 'PGRST116', message: 'No rows found' } });
            return resolve({ data: normalizeRecord(list.items[0]), error: null });
          }
          return resolve({ data: list.items.map(normalizeRecord), error: null });
        } catch (e) {
          return resolve({ data: null, error: e });
        }
      },
      insert(rows) {
        const col = this._collection;
        let _single = false;
        return {
          select() { return this; },
          single() { _single = true; return this; },
          async then(resolve) {
            try {
              const row = Array.isArray(rows) ? rows[0] : rows;
              const record = await pb.collection(col).create(row);
              const normalized = normalizeRecord(record);
              return resolve({ data: _single ? normalized : [normalized], error: null });
            } catch (e) {
              return resolve({ data: null, error: e });
            }
          }
        };
      },
      update(data) {
        const col = this._collection;
        const filters = [];
        return {
          eq(field, val) { filters.push(`${field}="${val}"`); return this; },
          async then(resolve) {
            try {
              const filter = filters.join(' && ');
              const list = await pb.collection(col).getList(1, 1, { filter });
              if (list.items.length === 0) throw new Error('Record not found');
              const record = await pb.collection(col).update(list.items[0].id, data);
              return resolve({ data: normalizeRecord(record), error: null });
            } catch (e) {
              return resolve({ data: null, error: e });
            }
          }
        };
      },
      delete() {
        const col = this._collection;
        const filters = [];
        return {
          eq(field, val) { filters.push(`${field}="${val}"`); return this; },
          async then(resolve) {
            try {
              const filter = filters.join(' && ');
              const list = await pb.collection(col).getList(1, 1, { filter });
              if (list.items.length === 0) throw new Error('Record not found');
              await pb.collection(col).delete(list.items[0].id);
              return resolve({ data: null, error: null });
            } catch (e) {
              return resolve({ data: null, error: e });
            }
          }
        };
      }
    };
  };

  const auth = {
    async getSession() {
      const token = pb.authStore.token;
      const model = pb.authStore.model;
      if (token && model && pb.authStore.isValid) {
        return { data: { session: { user: { id: model.id, email: model.email } } } };
      }
      return { data: { session: null } };
    },
    onAuthStateChange(callback) {
      const token = pb.authStore.token;
      const model = pb.authStore.model;
      if (token && model && pb.authStore.isValid) {
        setTimeout(() => callback('SIGNED_IN', { user: { id: model.id, email: model.email } }), 0);
      }
      const unsub = pb.authStore.onChange((token, model) => {
        const session = (token && model) ? { user: { id: model.id, email: model.email } } : null;
        callback(session ? 'SIGNED_IN' : 'SIGNED_OUT', session);
      });
      return { data: { subscription: { unsubscribe: unsub } } };
    },
    async signInWithPassword({ email, password }) {
      try {
        const result = await pb.collection('users').authWithPassword(email, password);
        return { data: { user: { id: result.record.id, email: result.record.email } }, error: null };
      } catch (e) {
        return { data: null, error: e };
      }
    },
    async signOut() {
      pb.authStore.clear();
    }
  };

  return { from, auth };
};

const shim = makeShim();

const supabase = {
  auth: shim.auth,
  from: shim.from,
};

export default supabase;
